__turbopack_context__.v({
  "divider": "H979oW_divider",
  "label": "H979oW_label",
  "measureRow": "H979oW_measureRow",
  "pill": "H979oW_pill",
  "strip": "H979oW_strip",
  "visuallyHidden": "H979oW_visuallyHidden",
});
